import { Component } from '@angular/core';
import { IconBase } from 'src/app/icons/icon.base';
import { IconConfig } from 'src/app/icons/icon.config';

@Component({
  selector: 'fit-navigation-down-right-icon',
  templateUrl: './navigation-down-right.component.html'
})
export class NavigationDownRightComponent extends IconBase {

  constructor(config?: IconConfig) {
    super(config);
  }
}
